import {createModel} from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {ProSkillAssureTrackLevelModel} from "~~/package/mapper/proSkillAssure/model/ProSkillAssureTrackLevelModel";
import {TrackType} from "~~/package/mapper/track/model/TrackType";

export class ProSkillAssureTrackModel extends Model {
    constructor(
        public trackId: number = 0,
        public trackType: TrackType = TrackType.SKILL,
        public category: string = "",
        public categories: string[] = [],
        public moreCategoryOpenFlag: boolean = false,
        public trackTitle: string = "",
        public description: string = "",
        public briefDescription: string = "",
        public difficulty: string = "",
        public trackLevelAssessmentSetVOList: ProSkillAssureTrackLevelModel[] = [],
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureTrackModel>): ProSkillAssureTrackModel {
        return createModel<ProSkillAssureTrackModel>(ProSkillAssureTrackModel, {
            ...model
        });
    }
}
